import React, { useEffect, useState } from "react";
import { Icon, SvgIcon, useTheme } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Assets from "./Assets";

const useStyles = makeStyles()((theme) => {
  return {
    iconStyle: {
      verticalAlign: "middle",
      marginTop: "5px",
    },
    spriteSvg: {
      "--primary-fill": theme.palette.primary.main,
      "--border-fill": theme.palette.mode === "dark" ? "#ccc" : "#222222",
    },
    fontIcons: {
      position: "relative",
      overflow: "initial",
      "&:before,&:after": {
        position: "absolute",
        left: 0,
        top: 0,
      },
    },
  };
});

export const IconWrapper = ({
  id,
  icon,
  viewBox,
  width,
  height,
  style,
  fontSize,
  color,
  onClick,
  cursor,
  iconLink,
}) => {
  const { classes, cx } = useStyles();

  return id ? (
    <svg
      className={cx(classes.iconStyle, classes.spriteSvg)}
      cursor={cursor ? cursor : "pointer"}
      width={width || "45"}
      height={height || "45"}
      viewBox={viewBox || "0 0 50 50"}
      style={{ width: "45px", fontSize, ...style }}
      onClick={onClick}
    >
      <use xlinkHref={`/assets/img/sprite.svg?v=1.3#${id}`}></use>
    </svg>
  ) : iconLink ? (
    <Assets
      src={iconLink}
      width={width}
      color={color}
      style={{ cursor: cursor ? cursor : "pointer", fontSize, ...style }}
      onClick={onClick}
    />
  ) : (
    <Icon
      fontSize={fontSize}
      baseClassName="icon"
      className={cx(classes.fontIcons, `icon-${icon}`)}
      color={color}
      style={{ cursor: cursor ? cursor : "pointer", fontSize, ...style }}
      onClick={onClick}
    ></Icon>
  );
};

export const IllustrationsWrapper = ({
  filename,
  imgProps = {},
  asSvg = false,
}) => {
  const theme = useTheme();
  const { style = {}, ...rest } = imgProps;
  const [svgData, setSvgData] = useState(null);
  const [svgLoadFailed, setSvgLoadFailed] = useState(false);

  useEffect(() => {
    if (asSvg) {
      fetch(`/assets/img/illustrations/${filename}`)
        .then((t) => t.text())
        .then((data) => {
          data = (data || "")
            .replace(/var\(--primary-fill.+?\)/gi, theme.palette.primary.main)
            .replace(
              /var\(--border-fill.+?\)/gi,
              theme.palette.mode === "dark" ? "#ccc" : "#222222"
            );
          setSvgData(`data:image/svg+xml;base64,${btoa(data)}`);
        })
        .catch(() => setSvgLoadFailed(true));
    }
  }, [filename, asSvg, theme.palette.primary.main, theme.palette.mode]);

  return asSvg ? (
    svgData ? (
      <img
        src={svgData}
        style={{ maxWidth: 200, width: "100%", ...style }}
        {...rest}
      />
    ) : (
      <div style={{ minHeight: 180 }}></div>
    )
  ) : (
    <img
      src={`/assets/img/illustrations/${filename}`}
      style={{ maxWidth: 200, width: "100%", ...style }}
      {...rest}
    />
  );
};
